import { eventBus } from "@codestreet/event-bus";

import { generateEventBusName } from "./generateEventBusName";
import { ResponseStatusCodes } from "./responseStatusCodes";

import type { ApiEventBusErrorCallbackPayload } from "./client.types";

export function useApiErrorEventBus(statusCode: ResponseStatusCodes) {
  const eventBusName = generateEventBusName(String(statusCode));
  return {
    on(callback: (data: ApiEventBusErrorCallbackPayload) => void) {
      eventBus.on(eventBusName, callback);
    },
    off(callback: (data: ApiEventBusErrorCallbackPayload) => void) {
      eventBus.off(eventBusName, callback);
    },
  };
}
